export default "__VITE_ASSET__5e42af25__"